import { ReportReducerState, ReportResponse } from './types';

function cleanReport(state: ReportReducerState): void {
  state.total = 0;
  state.list = null;
}

function setReport(state: ReportReducerState, payload: ReportResponse): void {
  const currentItems = state.list ?? [];

  state.list = currentItems.concat(payload.itemList);
  state.total = payload.totalCount;
}

export const reportReducer = {
  cleanReport,
  setReport,
};
